module.exports = __webpack_public_path__ + "media/top/icon_question-40215071.svg";